import React, { useState, useEffect, useRef } from "react";
import { get } from "lodash";
import { connect } from "react-redux";
import moment from "moment";
import { reduxForm, Field } from "redux-form";
import PaginatedTable from "../../sharedComponents/tableWithPagination";

import { FormField } from "../../sharedComponents/formField";
import { required, max100, max250 } from "../../constants/formValidators";
import { getCountryList, getReplacementList, submitTestimonial, getDetailTestimonial } from "../../store/actions";

const TestimonialEdit = ({
	initialValues,
	getCountryList,
	countryList,
	getReplacementList,
	replacementList,
	handleSubmit,
	submitTestimonial,
	setActiveTab,
	getDetailTestimonial,
	match
}) => {
	const testimonialId = (match && match.params && match.params.id) || null;
	const ref = useRef(null);

	const [showReplacementList, setShowReplacementList] = useState(false);
	useEffect(() => {
		getCountryList();
		getReplacementList();
	}, [getCountryList, getReplacementList]);

	const columns = [
		{
			Header: "Code",
			accessor: "code",
			width: 300,
			sortable: false
		},
		{
			Header: "Result",
			accessor: "result",
			sortable: false,
			Cell: ({ value }) => {
				return <span className="text-wrap" dangerouslySetInnerHTML={{ __html: value }} />;
			}
		}
	];

	const renderReplacementTable = () => {
		setShowReplacementList(!showReplacementList);
		if (!showReplacementList && ref && ref.current) {
			ref.current.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}
	};

	const saveTestimonial = (values) => {
		const successHandler = () => {
			getDetailTestimonial(`${testimonialId}`);
			setActiveTab(1);
		};
		const queryValues = {
			...values
		};
		submitTestimonial(queryValues, successHandler);
	};

	return (
		<form className="p-4" onSubmit={handleSubmit(saveTestimonial)}>
			<div className="row mt-3">
				<div className="col-6">
					<div className="row justify-content-between">
						<div className="col-4">
							<p className="mb-0"> Created </p>
							<p className="font-weight-bold mb-0">
								{initialValues.created ? moment(initialValues.created).format("YYYY-MM-DD") : "-"}{" "}
							</p>
						</div>
						<div className="col-4">
							<p className="mb-0"> Last Updated By </p>
							<p className="font-weight-bold mb-0">
								{initialValues.saved_by && initialValues.saved_by.first_name}
							</p>
						</div>
						<div className="col-4">
							<p className="mb-0"> Last Updated Date </p>
							<p className="font-weight-bold mb-0">
								{initialValues.saved_last ? moment(initialValues.saved_last).format("YYYY-MM-DD") : "-"}{" "}
							</p>
						</div>
					</div>
					<div className="row justify-content-between mt-1">
						<Field
							label="Active"
							name="active"
							type="checkbox"
							formGroupClass="col-4 mt-4 pt-1"
							component={FormField}
						/>
						<Field
							label="Featured"
							name="featured"
							type="checkbox"
							formGroupClass="col-4 mt-4 pt-1"
							component={FormField}
						/>
						<Field
							label="Homepage"
							name="homepage"
							type="checkbox"
							formGroupClass="col-4 mt-4 pt-1"
							component={FormField}
						/>
					</div>
					<div className="row mt-1">
						<Field
							label={"Country"}
							name={"country"}
							type="select"
							formGroupClass="col-6"
							options={countryList ? countryList : []}
							component={FormField}
							validate={[required]}
						/>
					</div>
					<div className="row mt-1">
						<Field
							label="Quotes - limit 100 chars"
							name="quotes"
							type="text"
							formGroupClass="col-12"
							component={FormField}
							validate={[max100]}
						/>
						<Field
							label="Blurb - limit 250 chars"
							name="blurb"
							type="textarea"
							formGroupClass="col-12"
							component={FormField}
							validate={[max250]}
						/>
						<Field
							label="Fulltext "
							name="fulltext"
							type="textarea"
							formGroupClass="col-12"
							component={FormField}
						/>
					</div>
				</div>

				<div className="col-6">
					<div className="border rounded-lg p-4">
						<h5 className="font-weight-bold text-primary-dark"> Stories as submitted by the user</h5>
						<div className="row border-bottom">
							<div className="col-6">
								<p className="mb-0">Member</p>
								<p className="font-weight-bold">
									{initialValues && initialValues.member_details
										? initialValues.member_details.first_name +
										  initialValues.member_details.middle_name +
										  initialValues.member_details.last_name
										: null}
								</p>
							</div>
							<div className="col-6">
								<p className="mb-0">Submitted</p>
								<p className="font-weight-bold"></p>
							</div>
						</div>
						<div
							className="mt-4"
							dangerouslySetInnerHTML={{
								__html: initialValues && initialValues.fulltext_html ? initialValues.fulltext_html : ""
							}}
						/>
					</div>
					<div className="d-flex flex-row justify-content-end mt-3">
						<button
							type="button"
							className="btn btn-primary-dark btn-ghost text-uppercase mr-3"
							onClick={renderReplacementTable}>
							replacement syntax
						</button>
						<button type="submit" className="btn btn-primary-dark text-uppercase">
							SAVE & NEXT
						</button>
					</div>
				</div>
			</div>

			<div ref={ref}>{showReplacementList ? <PaginatedTable data={replacementList} columns={columns} /> : []}</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const { Testimonials } = state;
	return {
		countryList: get(Testimonials, "countries", {}),
		replacementList: get(Testimonials, "replacements", {}),
		initialValues: get(Testimonials, "testimonialDetail", {})
	};
};

const mapDispatchToProps = { getCountryList, getReplacementList, submitTestimonial, getDetailTestimonial };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "FinalEditForm",
		enableReinitialize: true
	})(TestimonialEdit)
);
